<script>
import axios from "axios";
import { GravyPath } from "@/path";

export default {
  props: ["ticket"],
  mounted() {
    if (this.ticket.extra_details.order) {
      this.getOrder(this.ticket.extra_details.order);
    }
  },
  data() {
    return {
      order: null,
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      cdn: process.env.VUE_APP_AWS_CDN,
    };
  },
  methods: {
    async getOrder(v) {
      try {
        let res = await axios.get(
          this.base_url + GravyPath.ORDERS.GET + "/" + v
        );
        if (res.data.status) {
          this.order = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getLink(v) {
      return process.env.VUE_APP_AWS_CDN + "/" + v;
    },
  },
};
</script>

<template>
  <b-card>
    <p style="font-size: 16px">
      <b> {{ ticket.restaurant.name }}</b>
    </p>
    <b-card-header
      >Ticket: # {{ ticket.ticket_id }}
      <p>
        Priority : <b-badge variant="success">{{ ticket.priority }}</b-badge>
      </p></b-card-header
    >
    <b-card-body>
      <h4 style="text-transform: capitalize">
        Issue : {{ ticket.extra_details.issue.split("_").join(" ") }}
      </h4>
      <template v-if="ticket.extra_details.order">
        <hr />
        <p><b>Order #:</b> {{ ticket.extra_details.order }}</p>
        <!-- <hr /> -->
      </template>
      <br />
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th
              v-if="
                ticket.extra_details.issue == 'missing_item/qty' ||
                ticket.extra_details.issue == 'excess_qty'
              "
            >
              Qty Billed
            </th>
            <th
              v-if="
                ticket.extra_details.issue != 'missing_item/qty' &&
                ticket.extra_details.issue != 'damaged_item/pkg' &&
                ticket.extra_details.issue != 'excess_qty'
              "
            >
              Qty
            </th>
            <th v-if="ticket.extra_details.issue == 'missing_item/qty'">
              Qty Received
            </th>
            <th v-if="ticket.extra_details.issue == 'excess_qty'">
              Return Qty
            </th>
            <th v-if="ticket.extra_details.issue == 'damaged_item/pkg'">
              Qty Damaged
            </th>
            <th
              v-if="
                ticket.extra_details.issue == 'damaged_item/pkg' ||
                ticket.extra_details.issue == 'expired' ||
                ticket.extra_details.issue == 'non_moving_items'
              "
            >
              Images
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(t, index) in ticket.extra_details.items" :key="t">
            <td>{{ t.name }}</td>
            <td v-if="ticket.extra_details.issue == 'wrong_item'">
              <span>
                {{ t.qty_received ? t.qty_received : 0 }}
                {{ t.qty_received && t.qty_received == 1 ? "Pkt" : "Pkts" }}
              </span>
              <span v-if="t.pcs_received !== undefined && t.pcs_received !== 0">
                +
                {{ t.pcs_received ? t.pcs_received : 0 }}
                {{ t.pcs_received && t.pcs_received == 1 ? "pc" : "pcs" }}
              </span>
            </td>
            <td
              v-if="
                ticket.extra_details.issue == 'missing_item/qty' ||
                ticket.extra_details.issue == 'excess_qty'
              "
            >
              {{ t.qty_billed }}
            </td>
            <td v-if="ticket.extra_details.issue == 'missing_item/qty'">
              <span>
                {{ t.qty_received ? t.qty_received : 0 }}
                {{ t.qty_received && t.qty_received == 1 ? "Pkt" : "Pkts" }}
              </span>
              <span v-if="t.pcs_received !== undefined && t.pcs_received !== 0">
                +
                {{ t.pcs_received ? t.pcs_received : 0 }}
                {{ t.pcs_received && t.pcs_received == 1 ? "pc" : "pcs" }}
              </span>
            </td>
            <td v-if="ticket.extra_details.issue == 'excess_qty'">
              <span>
                {{ t.return_qty ? t.return_qty : 0 }}
                {{ t.return_qty && t.return_qty == 1 ? "Pkt" : "Pkts" }}
              </span>
              <span v-if="t.return_pcs !== undefined && t.return_pcs !== 0">
                +
                {{ t.return_pcs ? t.return_pcs : 0 }}
                {{ t.return_pcs && t.return_pcs == 1 ? "pc" : "pcs" }}
              </span>
            </td>
            <td v-if="ticket.extra_details.issue == 'damaged_item/pkg'">
              {{ t.qty_received }}
            </td>
            <td
              v-if="
                ticket.extra_details.issue == 'dicontinued_items' ||
                ticket.extra_details.issue == 'expired' ||
                ticket.extra_details.issue == 'non_moving_items'
              "
            >
              <span>
                {{ t.expired_qty ? t.expired_qty : 0 }}
                {{ t.expired_qty && t.expired_qty == 1 ? "Pkt" : "Pkts" }}
              </span>
              <span v-if="t.expired_pcs !== undefined && t.expired_pcs !== 0">
                +
                {{ t.expired_pcs ? t.expired_pcs : 0 }}
                {{ t.expired_pcs && t.expired_pcs == 1 ? "pc" : "pcs" }}</span
              >
            </td>
            <td
              v-if="
                ticket.extra_details.issue == 'damaged_item/pkg' ||
                ticket.extra_details.issue == 'expired' ||
                ticket.extra_details.issue == 'non_moving_items'
              "
            >
              <div
                v-if="
                  ticket.extra_details.images &&
                  ticket.extra_details.images[index]?.length
                "
              >
                <a
                  :href="getLink(file)"
                  :key="file"
                  target="_blank"
                  v-for="file in ticket.extra_details.images[index]"
                >
                  <img
                    :src="cdn + '/' + file"
                    alt="some"
                    :key="file"
                    height="100px"
                    style="margin-left: 5px"
                  />
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card-body>
  </b-card>
</template>

<style></style>
